define('gigaset_contentbridge/components/gallery',[
	"jquery",
	"cartware/components/_base"
], function(
	$,
	Component
) {
	return Component.create({
		$init: function () {
			// teaser-gallery
			$('.ext-teaser-gallery').each(function(){
				var $teaser = $(this),
					$galleryThumbs = $teaser.find('.gallery-thumbs a'),
					$galleryImg = $('<div/>', {'class':'gallery-image'}).appendTo($teaser);

				$galleryThumbs.click(function(ev) {
					var $el = $(this);
					$galleryThumbs.removeClass('current');
					$el.addClass('current');
					$galleryImg.fadeOut(function(){
						$galleryImg.empty();
						$('<img/>', {'src': $el.attr('href')}).appendTo($galleryImg);
						$galleryImg.fadeIn();
					});
					ev.preventDefault();
				});

				$galleryThumbs.first().trigger('click');
			});
		}
	});
});
